export default __webpack_public_path__ + "static/media/Read-Bold_V3000.5308f647.woff2";